/**
 * @description 清除filter
 * @param data{}
 * @returns 
 */
const clearFilter = () => {
    localStorage.setItem("xinzangwuyouFilter", "");
    localStorage.setItem("accountFilter", "");
    localStorage.setItem("danganFilter", "");
    localStorage.setItem("yingyangkuFilter", "");
    localStorage.setItem("yundongkuFilter", "");
    localStorage.setItem("zhibiaokuFilter", "");
    localStorage.setItem("ganyukuFilter", "");
    localStorage.setItem("xiyaokuFilter", "");
    localStorage.setItem("jianyankuFilter", "");
    localStorage.setItem("jianchakuFilter", "");
    localStorage.setItem("kepukuFilter", "");
    localStorage.setItem("sourceFilter", "");
    localStorage.setItem("cepingFilter", "");
}
export {
    clearFilter
};